export default __webpack_public_path__ + "static/slider_2-102cdeba6e4b6fdb149ea0353e7c8b39.png";